import {
    createColumns,
    DataTableColumn,
} from '@/components/ui/data-table-customized'
import { Business } from '@/modules/Business/types/response'
import { TFunction } from 'i18next'

export const createBusinessColumns = (
    t: TFunction
): DataTableColumn<Business>[] => {
    return createColumns<Business>([
        {
            key: 'employee_name',
            title: t('employee_name'),
            width: 200,
            pinned: 'left',
        },
        {
            key: 'business_timerange',
            title: t('business_dates'),
            width: 250,
            cellClassName: 'text-right',
            formatter: {
                type: 'timerange',
                startKey: 'business_startdate',
                endKey: 'business_enddate',
                format: 'DD/MM/YYYY HH:mm',
            },
        },
        { key: 'business_place', title: t('business_place'), width: 200 },
        { key: 'business_content', title: t('business_content'), width: 200 },
        { key: 'department_name', title: t('department_name'), width: 200 },
        { key: 'position_name', title: t('position_name'), width: 200 },
    ])
}
